import { Injectable, EventEmitter } from "@angular/core";

@Injectable({ providedIn: "root" })
export class EventService {
	public onBookingSuccessfull = new EventEmitter();
	public onAccountLoad = new EventEmitter();
	public onBookClick = new EventEmitter();

	constructor() {}
}